<template>
  <router-link
    class="component"
    :to="{
      name: `${category}-slug`,
      params: {
        slug: path
      }
    }"
  >
    <component :is="element">{{ name }}</component>
    <span v-if="price !== 0">{{ conversionPrice }}</span>
  </router-link>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    path: {
      type: String,
      required: true
    },
    thumbnail: {
      type: String,
      required: true
    },
    price: {
      type: Number,
      default: 0
    },
    element: {
      type: String,
      default: "h2"
    },
    category: {
      type: String,
      required: true
    }
  },
  computed: {
    conversionPrice() {
      if (this.price.length === 2) {
        return `¥${this.price[0].toLocaleString()} ~ ¥${this.price[1].toLocaleString()}`;
      } else {
        return `¥${this.price[0].toLocaleString()}`;
      }
    },
    conversionThumbnail() {
      return require(`@/assets/${this.thumbnail}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.component {
  margin: 1em 0;
  width: 45%;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba($color: #000, $alpha: 0.6);
  overflow: hidden;
  // @media screen and (min-width: 600px) and (max-width: 1279px) {
  //   & {
  //     width: 30%;
  //   }
  // }
  // @media screen and (min-width: 1280px) {
  //   & {
  //     width: 24%;
  //   }
  // }
  img {
    width: 100%;
  }
  h2,
  h3 {
    text-align: center;
    padding: 0.5em 0;
  }
  span {
    text-align: right;
    padding: 0 0.5em 0.25em 0;
  }
}
</style>
